import React from 'react';
import { bonuses } from '../data/resources';
import { BonusOfferTag } from './BonusOfferTag';
export function Bonuses() {
  return <section aria-labelledby="bonus-title" className="bg-sand px-5 sm:px-8 py-16 sm:py-24" data-id="element-27" data-mp="piobato1lgc8">
      <div className="max-w-6xl mx-auto" data-id="element-28" data-mp="aua7afew3lu3">
        <div className="max-w-2xl" data-id="element-29" data-mp="at8tw4aein97">
          <h2 id="bonus-title" className="font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-teal" data-id="element-30" data-mp="fteej0i979hs">
            5 ressources complémentaires incluses
          </h2>
          <p className="mt-4 text-base sm:text-lg leading-relaxed text-ink/80" data-id="element-31" data-mp="5vqhu5137rwz">
            Pour préparer votre matériel, vous entraîner et poursuivre vos créations.
          </p>
        </div>

        <div className="mt-12 sm:mt-16 space-y-8 sm:space-y-10" data-id="element-32" data-mp="3t0g58dlqoad2">
          {bonuses.map((bonus, i) => {
          const reversed = i % 2 === 1;
          return <article key={bonus.id} className="grid md:grid-cols-2 items-center rounded-[2rem] bg-ivory overflow-hidden shadow-soft" data-id="element-33" data-mp="1mart7lkv262h" data-mpi={i}>
                <div className={`aspect-square ${reversed ? 'md:order-2' : ''}`} data-id="element-34" data-mp="3ieg6r1msq2zs">
                  <img src={bonus.image} alt={bonus.imageAlt} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-35" data-mp="3icbxe464obs4" />
                </div>
                <div className="p-7 sm:p-10 lg:p-14" data-id="element-36" data-mp="3r5owjnusc9mn">
                  <p className="font-serif text-lg font-semibold text-coral-deep" data-id="element-37" data-mp="3n54ymi2e11zg">
                    Bonus {bonus.number}
                  </p>
                  <h3 className="mt-2 font-serif text-2xl sm:text-3xl font-semibold text-teal leading-snug" data-id="element-38" data-mp="2zgltucijr7c4">
                    {bonus.name}
                  </h3>
                  <p className="mt-3 font-serif italic text-lg text-ink" data-id="element-39" data-mp="38g0id6f5l7tz">{bonus.benefit}</p>
                  <p className="mt-4 text-base leading-relaxed text-ink/75 max-w-md" data-id="element-40" data-mp="33h5qlez7k8xq">
                    {bonus.description}
                  </p>
                  <div className="mt-6" data-id="element-41" data-mp="noq5uuwu9mz7">
                    <BonusOfferTag referencePrice={bonus.referencePrice} data-id="element-42" data-mp="iqyh29rhqgz8" />
                  </div>
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}